import React, { useState, useEffect } from "react";
import { Upload, message } from "antd";
import "./UploadClassVideos.css";
import VideoItem from "../VideoItem/VideoItem";
import { createVideoId } from "../../Utilities/videoApi";

const UploadClassVideos = ({ classId, classVideos }) => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const accessToken = localStorage.getItem("accessToken");
  const storedDeviceId = localStorage.getItem("deviceId");
  const storedUserIp = localStorage.getItem("userIp");

  const formatTitle = (str) => {
  if (!str) return str;
  
  return str
    .toLowerCase()
    .split(' ')
    .map(word => {
      if (word.length === 0) return word;
      // Handle hyphenated words (e.g., "state-of-the-art")
      if (word.includes('-')) {
        return word.split('-')
          .map(subWord => subWord.charAt(0).toUpperCase() + subWord.slice(1))
          .join('-');
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
};

  useEffect(() => {
    console.log("Initializing videos from classVideos", classVideos);
    
    if (classVideos && classVideos.videos) {
      // Sort videos by updated_at in descending order (newest first)
      const sortedVideos = [...classVideos.videos].sort((a, b) => {
        return new Date(b.created_at) - new Date(a.created_at);
      });

      const initialVideos = sortedVideos.map((video, index) => ({
        videoId: video.video_id || video.id || `temp-${Date.now()}-${index}`,
        title: video.title || video.file?.name || `Video ${index + 1}`,
        file: null,
        isUploaded: true,
        isIntro: video.is_intro,
        thumbnail: video.thumbnail_url || null,
        thumbnailUploaded: !!video.thumbnail_url,
        uploadProgress: 100, 
        existingVideo: true,
        createdAt: video.created_at || new Date().toISOString()
      }));
      
      console.log("Initialized videos:", initialVideos);
      setVideos(initialVideos);
    } else {
      console.log("No existing class videos found");
      setVideos([]);
    }
  }, [classVideos]);

  const handleInputChange = (videoId, field, value) => {
    console.log(`Updating video ${videoId}: ${field} = ${value}`);
    setVideos(videos.map(video => 
      video.videoId === videoId ? { ...video, [field]: value } : video
    ));
  };

  const handleThumbnailUpload = (videoId, file) => {
    console.log(`Uploading thumbnail for video ${videoId}`);
    setVideos(videos.map(video => {
      if (video.videoId === videoId) {
        // Clean up previous thumbnail if it was a File object
        if (video.thumbnail instanceof File) {
          URL.revokeObjectURL(video.thumbnail);
        }
        return { 
          ...video, 
          thumbnail: file,
          thumbnailUploaded: false
        };
      }
      return video;
    }));
  };

  const handleRemoveVideo = async (videoId) => {
    setVideos(videos.filter(video => video.videoId !== videoId));
  };
const handleCreateVideo = async (file) => {
  console.log("Creating new video entry");
  setLoading(true);
  try {
    // Use the file name without extension as the title
    const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
    const title = formatTitle(fileNameWithoutExtension); // Format the title
    
    console.log("Creating video ID...");
    const videoId = await createVideoId(
      file,
      classId,
      title,
      videos.length === 0,
      accessToken,
      storedDeviceId,
      storedUserIp
    );
    
    const newVideo = {
      videoId,
      title,
      file,
      isUploaded: false,
      uploadProgress: 0,
      isIntro: videos.length === 0,
      thumbnail: null,
      thumbnailUploaded: false,
      existingVideo: false
    };
    
    setVideos([...videos, newVideo]);
    message.success('Video added successfully. Please fill in details and upload.');
  } catch (error) {
    console.error('Error handling upload:', error);
    message.error('Failed to add video. ' + (error.response?.data?.message || error.message));
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="upload-class-videos-container">
      <h4>Upload Class Videos</h4>

      <p className="upload-class-videos-sum-text">
        If you're teaching your first class on BeyondSchools, we recommend reviewing
        in our Teacher Help Center for a full overview of
        the class creation process.
      </p>

      <div className="upload-class-videos-render">
        <Upload.Dragger
          multiple={false}
          accept="video/*"
          showUploadList={false} 
          className="upload-dragger"
          disabled={loading}
          beforeUpload={(file) => {
            handleCreateVideo(file);
            return false;
          }}
        >
          <p className="upload-text">
            {loading ? "Processing..." : 
            (videos.length === 0 ? "Drop your video here, or browse" : `You can add more videos`)}
          </p>
        </Upload.Dragger>

        {videos.length > 0 && (
          <div className="video-list">
            {videos.map((video) => (
              <VideoItem
                key={video.videoId}
                video={video}
                handleInputChange={handleInputChange}
                handleRemoveVideo={handleRemoveVideo}
                handleThumbnailUpload={handleThumbnailUpload}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UploadClassVideos;